import axios from 'axios';
import { isObject, assign, toPairs } from 'lodash';

const STUDENTS_PRE = window.REQUEST_URL;

/**
 * 将对象转化为 formdata 格式
 * @param {object} src 对象
 * @returns formdata
 */
function obj2formData(src) {
  const results = new FormData();

  if (isObject(src)) {
    toPairs(src).forEach((item) => {
      results.append(item[0], item[1]);
    });
    return results;
  }

  return src;
}

function request(options) {
  const axiosOptions = assign({}, options, {
    url: STUDENTS_PRE + options.url,
  });

  // post 方法使用 formdata 形式上传数据
  if (axiosOptions.method && axiosOptions.method.toUpperCase() === 'POST') {
    assign(axiosOptions, {
      data: options.data && obj2formData(options.data),
      headers: {
        'Content-Type': 'multipart/form-data',
        ...axiosOptions.headers,
      },
    });
  }

  return axios(axiosOptions).then((res) => {
    const code = res.data.statusCode;
    switch (code) {
      // 课堂不存在
      case 40401:
        setTimeout(() => {
          window.g_app_history.push('/error');
        });
        return Promise.reject(res.data);
      case 200:
        return Promise.resolve(res.data);
      default:
        return Promise.reject(res.data);
    }
  });
}

export default request;
